import {Typography} from '~library/atoms/Typography';
import {LockLineIcon} from '~library/svg/LockLineIcon';
import {CameraIcon} from '~library/svg/v2/CameraIcon';

export const MESSAGE_STATES = Object.freeze({
  CREATE_FLOW: 'create-flow',
  PRE_EVENT: 'pre-event',
  PRE_RSVP: 'pre-rsvp',
  EMPTY: 'empty',
});

const MESSAGE_OBJ = Object.freeze({
  [MESSAGE_STATES.CREATE_FLOW]: {
    message: 'Photos will appear here!',
    title: '',
    icon: <CameraIcon />,
  },
  [MESSAGE_STATES.PRE_EVENT]: {
    message: 'You’ll be able to add photos once the event starts.',
    title: 'Coming soon!',
    icon: <CameraIcon />,
  },
  [MESSAGE_STATES.PRE_RSVP]: {
    message: 'RSVP to view and share photos for this event.',
    title: 'Want to view the photos?',
    icon: <LockLineIcon />,
  },
  [MESSAGE_STATES.EMPTY]: {
    message: 'No photos yet - be the first to share!',
    title: '',
    icon: <CameraIcon />,
  },
});

interface ModuleMessagingProps {
  messagingState: string;
}

export const ModuleMessaging = ({messagingState}: ModuleMessagingProps) => {
  const {message, title, icon} = MESSAGE_OBJ[messagingState as keyof typeof MESSAGE_OBJ];

  return (
    <>
      {icon}
      {title && (
        <Typography variant="paragraph2" data-qa-id="photos-message-title" semibold>
          {title}
        </Typography>
      )}
      {message && (
        <Typography
          variant="paragraph3"
          data-qa-id="photos-message-message"
          className="photos__message"
        >
          {message}
        </Typography>
      )}
    </>
  );
};
